export default __webpack_public_path__ + "assets/img/ict-ellipse.251206e4befe49ebe4e29a34b5d3593f.svg";